import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames'
import cookie from 'react-cookies'
import InfiniteScroll from 'react-infinite-scroll-component'
import {EasyMiddleware} from './EasyMiddleware'

const styles = {
    shifts: {
        borderBottom: 'solid 1px white',
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        paddingBottom: "4%",
        paddingTop: "4%"
    },

    date: {
        fontFamily: "Saira",
        fontSize: "20px",
        fontWeight: "600",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "0.9",
        letterSpacing: "-0.5px",
        color: "#007066",
        textTransform: "uppercase",
        marginBottom: "3%"
    },

    day: {
        fontFamily: "Saira",
        fontSize: "15px",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "semi-condensed",
        lineHeight: "1.2",
        letterSpacing: "normal",
        color: "#000000",
        display: "flex"
    },

    wage: {
        fontFamily: "Saira Semi Condensed",
        fontSize: "20px",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "semi-condensed",
        lineHeight: "0.9",
        letterSpacing: "-0.3px",
        textAlign: "right",
        color: "#007066",
        width: "33%",
        float: "right"
    },

    dateContainer: {
        width: "60%"
    },

    imgWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "20%",
        height: "5vh",
    },

    black: {
        color: "black"
    },

    shiftImg: {
        maxWidth: "25px"
    },

    month: {
        display: "flex",
        justifyContent: "space-between"
    },

    dayName: {
      textTransform: "capitalize"
    },
}


class MySchedules extends Component {

    constructor(props) {
        super(props)
        this.state = {
            historySchedules: {},
            currentSchedules: {},
            token: cookie.load('apiToken'),
            nextPageUrl: 'api/user/my-schedule',
            hasMore: true,
        }
    }

    componentDidMount() {
        EasyMiddleware.checkResetPassword()

        this.loadSchedules();
    }

    loadSchedules = () => {
        axios.get(this.state.nextPageUrl, {headers: {Authorization: this.state.token}})
            .then((response) => {
                let responseData = response.data
                this.setState({
                    nextPageUrl: responseData.pagination.nextPageUrl,
                    hasMore: responseData.pagination.hasMorePage,
                    historySchedules: Object.assign(this.state.historySchedules, responseData.history),
                    currentSchedules: Object.assign(this.state.currentSchedules, responseData.current)
                })
            })
            .catch((response) => {
                if (error.response.status === 401) {
                    window.postMessage('logout')
                }
            })
    }

    calculateSalary = (schedules) => {
        let salary = []
        let schedulesKeys = Object.keys(schedules)

        if (schedulesKeys.length > 0) {

            schedulesKeys.map((date) => {
                let scheduleDate = new Date(date)
                let month = new Intl.DateTimeFormat('hu-HU', {year: 'numeric', month: 'long'}).format(scheduleDate)
                let wage = schedules[date].wage * 8;

                if (salary[month] === undefined) {
                    salary[month] = wage
                } else {
                    salary[month] += wage
                }

            })

        }
        return salary
    }

    renderCurrentSchedules = () => {
        const {classes} = this.props
        const {currentSchedules} = this.state
        let schedulesList = []
        let currentMonth = null

        if (Object.keys(currentSchedules).length === 0) return;

        let salary = this.calculateSalary(currentSchedules);

        Object.keys(currentSchedules).map((date) => {
            let scheduleDate = new Date(date)
            let month = new Intl.DateTimeFormat('hu-HU', {year: 'numeric', month: 'long'}).format(scheduleDate)

            if (currentMonth !== month) {
                currentMonth = month
                schedulesList.push(
                    <h3 className={classes.month}>
                        <span>{currentMonth}</span>
                        <span>{this.formatWage(salary[month])}</span>
                    </h3>
                )
            }

            let monthWithDay = new Intl.DateTimeFormat('hu-HU', {month: 'long', day: 'numeric'}).format(scheduleDate)

            schedulesList.push(
                <div className={classes.shifts}>
                    <div className={classes.imgWrapper}>
                        <img className={classes.shiftImg} src={this.getShiftIcon(currentSchedules[date].shift)}/>
                    </div>
                    <div className={classes.dateContainer}>
                        <div className={classes.date}>
                            {monthWithDay}
                        </div>
                        <div className={classes.day}>
                            <div className={classes.dayName}>
                                {currentSchedules[date].dayName}
                            </div>
                            ,&nbsp;
                            {currentSchedules[date].shiftName}
                        </div>
                    </div>
                    <div className={classes.wage}>
                        {this.formatWage(currentSchedules[date].wage)}
                    </div>
                </div>
            )
        })

        return schedulesList

    }

    formatWage = (wage) => {
        if (!wage) return ""
        return new Intl.NumberFormat('hu-HU', {
            style: 'currency',
            currency: 'HUF',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(wage)
    }

    renderHistoryCards = () => {
        const {classes} = this.props
        const {historySchedules} = this.state
        let scheduleList = []
        let currentMonth = null

        if (Object.keys(historySchedules).length === 0) return;

        let salary = this.calculateSalary(historySchedules);

        Object.keys(historySchedules).map((date) => {
            let scheduleDate = new Date(date)
            let month = new Intl.DateTimeFormat('hu-HU', {year: 'numeric', month: 'long'}).format(scheduleDate)

            if (month !== currentMonth) {
                currentMonth = month
                scheduleList.push(
                    <h3 className={classes.month}>
                        <span>{currentMonth}</span>
                        <span>{this.formatWage(salary[month])}</span>
                    </h3>
                )
            }

            let monthWithDay = new Intl.DateTimeFormat('hu-HU', {month: 'long', day: 'numeric'}).format(scheduleDate)

            scheduleList.push(
                <div className={classes.shifts}>
                    <div className={classes.imgWrapper}>
                        <img className={classes.shiftImg} src="/images/done-icon.png"/>
                    </div>
                    <div className={classes.dateContainer}>
                        <div className={classNames(classes.date, classes.black)}>
                            {monthWithDay}
                        </div>
                        <div className={classes.day}>
                            {historySchedules[date].dayName},&nbsp;
                            {historySchedules[date].shiftName}
                        </div>
                    </div>
                    <div className={classNames(classes.wage, classes.black)}>
                        {this.formatWage(historySchedules[date].wage)}
                    </div>
                </div>
            )
        })

        return scheduleList
    }

    getShiftIcon = (shift) => {
        switch (shift) {
            case 0:
                return "images/icon-0-white.svg"
            case 1:
                return "images/icon-1-white.svg"
            case 2:
                return "images/icon-2-white.svg"
        }
    }

    loader = () => (
        <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )

    render() {
        const {classes} = this.props

        return (
            <div>
                <h1>Napló</h1>
                <div className="active-shifts-container">
                    <h2>Aktív Műszakok</h2>
                    <div className="active-shifts">
                        {this.renderCurrentSchedules()}
                    </div>
                </div>

                <div className="history-shifts-container">
                    <h2>elvégzett Műszakok</h2>

                    <div className="history-shifts">
                        <InfiniteScroll
                            dateLength={Object.keys(this.state.historySchedules).length}
                            next={this.loadSchedules}
                            hasMore={this.state.hasMore}
                            loader={this.loader()}
                            refreshFunction={this.loadSchedules}
                        >
                            {this.renderHistoryCards()}
                        </InfiniteScroll>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(MySchedules)



// WEBPACK FOOTER //
// ./resources/js/components/MySchedules.js